import React, { useEffect, useRef } from 'react';
import './Checkbox.scss';
const CheckboxItem = ({
  onClick,
  disabled,
  label,
  checked,
  indeterminate,
  onChange,
}) => {
  const checkboxRef = useRef(null);
  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <label
      className='checkbox-treeview'
      style={{
        width: `${label ? '' : '1rem'}`,
        height: `${label ? '' : '1rem'}`,
        cursor: disabled ? 'not-allowed' : 'cursor-pointer',
      }}
    >
      <input
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        onClick={onClick}
        ref={checkboxRef}
        style={{ pointerEvents: disabled ? 'none' : 'unset' }}
        type='checkbox'
      />
      {label && <span>{label}</span>}
    </label>
  );
};
export default CheckboxItem;
